import { action, makeAutoObservable, observable } from "mobx";

// Tool Status Config Types
export type ToolStatus = {
  done: string;
  working?: string;
  waiting?: string;
  error?: string;
  cancel?: string;
};

export type ToolStatusConfig = Record<string, ToolStatus>;

// Pricing Benefits Config Types
export interface BenefitItem {
  label: string;
  isActive: boolean;
  is365Ulimited: boolean;
  desc?: string;
}

export interface PricingPlanConfig {
  memberCode: string;
  benifits: {
    basic: BenefitItem[];
    unlimitedAccess: BenefitItem[];
    unlockModels: BenefitItem[];
  };
  creditTooltips: string[];
}

export interface PricingPageConfig {
  plans: PricingPlanConfig[];
  faqLink: string;
  faqs: {
    question: string;
    answer: string;
  }[];
}

export interface HomeTopAnnouncementConfig {
  type: "default";
  startTime: number;
  endTime: number;
  content: string;
  contentMobile?: string;
  link?: string;
  button?: string;
}

export interface BannerConfig {
  homeTop?: HomeTopAnnouncementConfig;
}

export interface CdnConfig {
  video: {
    prod: string[];
    staging: string[];
    dev: string[];
  };
  image: {
    prod: string[];
    staging: string[];
    dev: string[];
  };
}

// Generic Config Store
export class ConfigStore {
  @observable toolConfig: ToolStatusConfig = {};
  @observable pricingPageConfig: PricingPageConfig = {
    plans: [],
    faqs: [],
    faqLink: "",
  };
  @observable bannerConfig: BannerConfig = {};
  @observable cdnConfig: CdnConfig = {
    video: { prod: [], staging: [], dev: [] },
    image: { prod: [], staging: [], dev: [] },
  };

  constructor() {
    makeAutoObservable(this);
  }

  @action setToolConfig(config: ToolStatusConfig) {
    this.toolConfig = config || {};
  }

  @action setPricingPageConfig(config: PricingPageConfig) {
    this.pricingPageConfig = config || { plans: [], faqs: [], faqLink: "" };
  }

  @action setBannerConfig(config: BannerConfig) {
    this.bannerConfig = config || {};
  }

  @action setCdnConfig(config: CdnConfig) {
    this.cdnConfig = config || {
      video: { prod: [], staging: [], dev: [] },
      image: { prod: [], staging: [], dev: [] },
    };
  }

  /**
   * Get pricing benefits for a specific member code
   */
  getPricingPlanConfig(memberCode: string): PricingPlanConfig | undefined {
    console.log(this.pricingPageConfig);

    return (this.pricingPageConfig.plans || []).find(
      (b) => b.memberCode === memberCode,
    );
  }
}

export const configStore = new ConfigStore();

// For backward compatibility, export the old store name
export const toolConfigStore = configStore;
